export default __webpack_public_path__ + "static/media/296.41ddf82b.png";